import React from "react";
import { Input, Space, Form, Result, Switch } from "antd";
import { Create, useForm } from "@refinedev/antd";
import { Authenticated, CanAccess, useTranslate } from "@refinedev/core";
import { ConfigurationResponse } from "@/types";

export const FlagCreatePage: React.FC = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps } = useForm<ConfigurationResponse>({
    resource: "api/configuration",
    action: "create",
  });

  return (
    <Authenticated key="feature_flags_create">
      <CanAccess
        resource="feature_flags"
        action="create"
        fallback={
          <Result
            status={403}
            title={t("pages.system.detail.accessForbidden")}
          />
        }
      >
        <Create
          saveButtonProps={saveButtonProps}
          wrapperProps={{
            style: { maxWidth: 800, margin: "auto" },
          }}
        >
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Form
              {...formProps}
              layout="vertical"
              initialValues={{ value: "false", type: "bool" }}
            >
              <Form.Item
                name="id"
                label={t("featureFlags.index.id")}
                rules={[{ required: true }]}
              >
                <Input placeholder="id" />
              </Form.Item>
              <Form.Item
                name="value"
                label={t("featureFlags.index.value")}
                valuePropName="checked"
                getValueFromEvent={(checked: boolean) =>
                  checked ? "true" : "false"
                }
                getValueProps={(value) => ({
                  checked: value === "true",
                })}
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={t("featureFlags.index.type")}
                name="type"
                rules={[{ required: true }]}
              >
                <Input placeholder="type" />
              </Form.Item>
            </Form>
          </Space>
        </Create>
      </CanAccess>
    </Authenticated>
  );
};
